import {FC} from 'react'
import {brandCopyright, WebSite} from '../../../_metronic/helpers'
import {SUPPORT_PHONE, SUPPORT_PHONE_LABEL} from '../../../_metronic/helpers/supportContact'
import {useAuth} from '../../modules/auth'
import {canUseTicketing} from '../../modules/auth/core/ticketingAccess'
import {hasTermsOfService, TermsViewerButton} from '../../modules/terms'

type Props = {
  // A ticket belongs to a business, so pages used before one exists (the registration guide)
  // turn the link off: it would only send the visitor to sign in and back to the same page.
  showTicketLink?: boolean
}

const SimpleFooter: FC<Props> = ({showTicketLink = true}) => {
  const {currentUser} = useAuth()
  const ticketingEnabled = showTicketLink && canUseTicketing(currentUser)

  return (
    <>
      <div className='w-100 text-center mt-3'>
        <h6>{brandCopyright}</h6>
      </div>
      <div className='w-100 text-center mt-3'>
        <div className='d-flex justify-content-center'>
          <div className='mx-5'>
            <a href={`${WebSite}`} target='_blank' rel='noreferrer'>
              <i className='lab la-edge fs-5 text-primary me-1'></i>
              وب سایت
            </a>
          </div>
          <div className='mx-5 ltr'>
            <a href={`tel:${SUPPORT_PHONE}`} target='_blank' rel='noreferrer'>
              <i className='las la-phone fs-5 text-primary ms-2'></i>
              {SUPPORT_PHONE_LABEL}
            </a>
          </div>
          {ticketingEnabled && (
            <div className='mx-5'>
              <i className='las la-comments fs-5 text-primary me-2'></i>
              <a href={`/ticket`} target='_blank' rel='noreferrer'>
                تیکت پشتیبانی
              </a>
            </div>
          )}
          {hasTermsOfService(currentUser) && (
            <div className='mx-5'>
              <i className='las la-file-contract fs-5 text-primary me-1' aria-hidden='true'></i>
              <TermsViewerButton />
            </div>
          )}
        </div>
      </div>
    </>
  )
}

export {SimpleFooter}
